import type { ScenePoint } from "./MapScene";

// Веса соседних точек (±2 шага, ±4 с): путь не дёргается от неточностей координат.
const WEIGHTS = [1, 2, 3, 2, 1] as const;

// Сглаженный путь: взвешенное среднее соседних живых точек; HP — как у самой точки.
export const smoothTrack = (track: readonly (ScenePoint | null)[]): (ScenePoint | null)[] =>
  track.map((point, index) => {
    if (point === null) {
      return null;
    }
    let sumX = 0;
    let sumY = 0;
    let total = 0;
    WEIGHTS.forEach((weight, k) => {
      const near = track[index + k - 2];
      if (near !== null && near !== undefined) {
        sumX += near[0] * weight;
        sumY += near[1] * weight;
        total += weight;
      }
    });
    return [sumX / total, sumY / total, point[2]];
  });
